import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=7c8d829e&scoped=true&"
import script from "./TabContent.vue?vue&type=script&lang=js&"
export * from "./TabContent.vue?vue&type=script&lang=js&"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=7c8d829e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d829e",
  null
  
)

export default component.exports